<!--MODAL Agregar Familia-->
<div mdbModal #agregarFamilia="mdb-modal" class="modal fade" id="basicExample" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <form [formGroup]='formData' novalidate (ngSubmit)="addEdit()">
        <div class="modal-header">
          <h4 class="modal-title w-100 text-left" id="myModalLabel" *ngIf="!isEditing">
            Agregar
          </h4>
          <h4 class="modal-title w-100 text-left" id="myModalLabel" *ngIf="isEditing">
            Editar
          </h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="agregarFamilia.hide()">
            <span aria-hidden="true">×</span>
          </button>
        </div>

        <div class="modal-body">
          <div class="container">
            <div class="row">
              <div class="col">
                <h5 class="modal-title w-100 text-left" id="myModalLabel">
                  Datos de Familia
                </h5>
              </div>
              <div class="col">
                <div class="switch info-switch">
                  <label>
                    Inactivo
                    <input type="checkbox" color="info" checked="" formControlName="activo" checked/>
                    <span class="lever"></span>
                    Activo
                  </label>
                </div>
              </div>
            </div>
            <br />
            <div class="row">
              <div class="col">
                <div class="md-form">
                  <input value="" type="text" id="nombre" class="form-control" placeholder="Nombre" maxLength="200"
                    required #nombre formControlName="nombre" maxlength="100" />
                  <label for="nombre">Nombre <span class="text-danger">(*)</span></label>
                  <div *ngIf="
                  formData.get('nombre').invalid &&
                  (formData.get('nombre').dirty ||
                  formData.get('nombre').touched)
                  ">
                    <mdb-error *ngIf="formData.get('nombre').hasError('required')">
                      Ingrese nombre
                    </mdb-error>
                    <mdb-error *ngIf="formData.get('nombre').hasError('maxlength')">
                      El nombre no puede superar los 100 caracteres
                    </mdb-error>
                    <mdb-error *ngIf="formData.get('nombre').hasError('minlength')">
                      El nombre debe tener como mínimo 5 caracteres
                    </mdb-error>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="md-form">
              <mdb-select [multiple]="false" [filterEnabled]="true" [highlightFirst]="false"
                placeholder="Seleccionar rubro" [options]="optionsRubros" formControlName="rubro"></mdb-select>
              <label>Rubro</label>
              <div *ngIf="
                      formData.get('rubro').invalid &&
                      (formData.get('rubro').dirty ||
                      formData.get('rubro').touched)
                  ">
                <mdb-error *ngIf="formData.get('rubro').hasError('required')">
                  Ingrese rubro
                </mdb-error>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer justify-content-between">
          <button type="button" class="btn btn-default waves-light" data-dismiss="modal" (click)="agregarFamilia.hide()"
            mdbWavesEffect>
            Cerrar
          </button>
          <button type="button" class="btn btn-secondary waves-light" mdbWavesEffect type="submit">
            Guardar
          </button>
        </div>
      </form>
    </div>
  </div>
</div>